<template>
  <div class="container-fluid" style="overflow-y: hidden">
    <div class="row" style="margin-bottom: 5px">
      <div class="col">
        <b-button-group>
          <b-button
            style="font-size: 12px; padding: 5px"
            variant="link"
            :disabled="currentSelectedItem == null"
            @click="updateItem()"
          >
            <svg
              height="24px"
              width="24px"
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 512 512"
              xml:space="preserve"
            >
              <title>{{ $store.state.localization.data.common.updateLabel }}</title>
              <path
                style="fill: #dd539c"
                d="M505.842,130.44L443.7,68.299L381.559,6.158c-9.099-9.101-24.973-7.982-35.449,2.495L239.856,114.905
	l32.955,32.955l45.663,45.665l45.665,45.661l32.955,32.955L503.35,165.889C513.827,155.412,514.944,139.539,505.842,130.44z"
              />
              <path
                style="fill: #efc377"
                d="M85.444,426.555L6.828,347.934c-4.373,4.373-6.825,10.295-6.828,16.48l0.003,55.312v68.969
	c0,6.438,2.61,12.262,6.825,16.478c4.218,4.215,10.044,6.825,16.478,6.825h68.966l55.314,0.002c6.182,0,12.11-2.458,16.478-6.825
	L85.444,426.555z"
              />
              <polygon
                style="fill: #f4d944"
                points="364.141,239.189 318.475,193.525 272.812,147.863 239.858,114.905 6.828,347.934 
	85.444,426.555 164.064,505.175 397.094,272.141 "
              />
              <path
                style="fill: #ecb555"
                d="M0.003,488.693c0,6.439,2.61,12.262,6.825,16.478l78.617-78.617L6.828,347.934
	c-4.373,4.373-6.825,10.295-6.828,16.48l0.003,55.312V488.693z"
              />
              <polygon
                style="fill: #f1cc30"
                points="318.475,193.525 272.813,147.863 239.858,114.905 6.828,347.934 85.444,426.555 "
              />
              <path
                style="fill: #db348a"
                d="M318.475,193.525L443.7,68.299L381.559,6.158c-9.099-9.101-24.973-7.982-35.449,2.493
	L239.856,114.905l32.955,32.955L318.475,193.525z"
              />
            </svg>
          </b-button>
          <b-button
              style="font-size: 12px; padding: 5px"
              variant="link"
              :disabled="currentSelectedItem == null"
              @click="syncItem()"
          >
            <svg
              height="24px"
              width="24px"
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>{{ $store.state.localization.data.common.syncLabel }}</title>
              <path
                style="fill:#dd539c"
                d="M370.7 133.3C339.4 102 298.2 84 256 84c-72.9 0-135.3 46.6-157.9 112h52.6c17.6-38.6 56.5-64 105.3-64 30.9 0 60.1 12.1 82.1 34.1l-41.4 41.4H428V64l-57.3 57.3zM142.7 378.7C174 410 215.2 428 257.4 428c72.9 0 135.3-46.6 157.9-112h-52.6c-17.6 38.6-56.5 64-105.3 64-30.9 0-60.1-12.1-82.1-34.1l41.4-41.4H84v144l58.7-58.7z"
              />
            </svg>
          </b-button>
        </b-button-group>
      </div>
    </div>

    <div class="row" style="height:100%;">
      <div class="col-12" style="height:100%;">
        <b-table
          class="textMiddle"
          style="height: 100%;"
          small
          hover
          bordered
          show-empty
          responsive
          head-variant="light"
          selectable
          select-mode="single"
          :items="azkFuelDepos"
          :fields="headers"
          v-bind:emptyText="$store.state.localization.data.common.table.noData"
          @row-clicked="itemClicked"
          v-bind:sticky-header="clientHeight"
        >
          <template #cell(fuelDepo)="data">
            {{ formatFuelDepo(data.item.fuelDepoId) }}
          </template>
          <template v-slot:empty="scope">
            <div class="row justify-content-md-center">
              <h5>{{ scope.emptyText }}</h5>
            </div>
          </template>
          <template>
            <span class="text-success"></span>
          </template>
        </b-table>
      </div>
    </div>
      <UpdateFuelDepoPage
        v-bind:fuelDepo="currentSelectedItem"
        v-bind:globalSettings="globalSettings"
        v-on:fuelDepoUpdatedSuccessEvent="fuelDepoUpdatedSuccessEvent"
        v-on:fuelDepoUpdatedFailEvent="fuelDepoUpdatedFailEvent"
        ref="update-item-page"
    ></UpdateFuelDepoPage>
    <b-modal ref="sync-entities-modal" @ok="syncEntitiesModalOk">
      <template v-slot:modal-header="{}">
        <div></div>
      </template>
      <div class="text-center" style="font-size: 12px">
        {{ this.$store.state.localization.data.mainPage.azk.syncEntitiesConfirm }}
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
          $store.state.localization.data.common.table.cancel
        }}</b-button>
        <b-button variant="success" style="font-size: 12px" @click="ok()">{{
          $store.state.localization.data.common.table.confirm
        }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { azkService } from "../../../../services";
import UpdateFuelDepoPage from "../UpdateFuelDepo/UpdateFuelDepoPage.vue";

export default {
  name: "ListFuelDeposPage",
  components: {
    UpdateFuelDepoPage,
  },
  props: {
    fuelTanks: Array,
    fuelDepos: Array,
    fuelDeposData: Array,
    globalSettings: Array,
  },
  data() {
    return {
      currentSelectedItem: null,
      azkFuelDepos: []
    };
  },
  watch: {
    combinedWatch: {
      immediate: true,
      handler([fuelDepos, globalSettings]) {
        if (!fuelDepos || !Array.isArray(fuelDepos) || fuelDepos.length === 0) return;
        if (!globalSettings || !Array.isArray(globalSettings) || globalSettings.length === 0) return;

        this.azkFuelDepos = [];
        for (let i = 0; i < fuelDepos.length; i++) {
          const settings = globalSettings.filter(x => x.fuelDepoId == fuelDepos[i].id);
          
          if (settings.length != 0) {
            const clientId = settings[0].clientId;
  
            const fuelDepoData = this.fuelDeposData.find(x => x.id == clientId);
            let lastOperation = '-', lastSyncTime = '-';

            if (fuelDepoData) {
              if (fuelDepoData.lastOperation) {
                lastOperation = this.$store.state.localization.data.mainPage.azk.fuelDepos.operationOptions[fuelDepoData.lastOperation];
              }

              if (fuelDepoData.lastSyncTime != 0) {
                lastSyncTime = new Date(fuelDepoData.lastSyncTime * 1000).toLocaleString("uk-UA");
              }
            }

            this.azkFuelDepos.push({
              id: fuelDepos[i].id,
              name: fuelDepos[i].name,
              clientId: clientId,
              ownerCode: settings.find(x => x.name == 'ownerCode')?.value,
              departmentCode: settings.find(x => x.name == 'departmentCode')?.value,
              searpCode: settings.find(x => x.name == 'searpCode')?.value,
              seCode: settings.find(x => x.name == 'seCode')?.value,
              lastSyncTime: lastSyncTime,
              lastOperation: lastOperation
            });
          } else {
            this.azkFuelDepos.push({
              id: fuelDepos[i].id,
              name: fuelDepos[i].name,
              clientId: 0,
              ownerCode: '',
              departmentCode: '',
              searpCode: '',
              seCode: '',
              lastSyncTime: '',
              lastOperation: ''
            });
          }
        }
      }
    }
  },
  computed: {
    combinedWatch() {
      return [this.fuelDepos, this.globalSettings];
    },
    headers() {
      const headers = [];

      for (let key in this.$store.state.localization.data.mainPage.azk.fuelDepos
          .tableColumns) {
            if (
              key == "id" ||
              key == "name" ||
              key == "lastSyncTime" ||
              key == "lastOperation"
            ) {
              headers.push({
                key: key,
                label:
                  this.$store.state.localization.data.mainPage.azk.fuelDepos.tableColumns[
                    key
                  ],
                sortable: true,
                thClass: "textMiddle",
              });
            }
        }

      return headers;
    },
    clientHeight() {
      const FUEL_TANKS_POSITION_Y = 140;

      return `${
        document.documentElement.clientHeight - FUEL_TANKS_POSITION_Y
      }px`;
    },
  },
  methods: {
    itemClicked(row) {
      this.currentSelectedItem = row;
    },
    async updateItem() {
      this.$refs["update-item-page"].open();
    },
    async syncItem() {
      this.$refs["sync-entities-modal"].show();
    },
    async syncEntitiesModalOk() {
      const updatedReport = await azkService.forceGetEntities(this.currentSelectedItem.clientId, this.currentSelectedItem.id);

      if (updatedReport.isSuccess) {
        alert(this.$store.state.localization.data.mainPage.azk.syncEntitiesRequesrSuccess);
      } else {
        alert(this.$store.state.localization.data.mainPage.azk.syncEntitiesRequesrError);
      }
    },
    formatFuelDepo(fuelDepoId) {
      for (let i = 0; i < this.fuelDepos.length; i++) {
        if (
          this.fuelDepos[i].id == fuelDepoId
        ) {
          return this.fuelDepos[i].name;
        }
      }

      return "";
    },
    fuelDepoUpdatedSuccessEvent() {
      this.currentSelectedItem = null;
      alert(this.$store.state.localization.data.common.entityUpdateSuccess.replace("[ENTITY_NAME]", this.$store.state.localization.data.mainPage.azk.fuelDepos.pageLabel));
      this.$emit("itemUpdatedEvent");
    },
    fuelDepoUpdatedFailEvent() {
      this.currentSelectedItem = null;
      alert(this.$store.state.localization.data.common.entityUpdateError.replace("[ENTITY_NAME]", this.$store.state.localization.data.mainPage.azk.fuelDepos.pageLabel));
      this.$emit("itemUpdatedEvent");
    },
  },
};
</script>
